import * as React from 'react';

import { SvgLoaderSignal } from '@coursera/coursera-ui/svg';

import 'css!./__styl__/Loader';

const Loader: React.FunctionComponent = () => (
  <div className="rc-Loader horizontal-box align-items-absolute-center p-b-2" data-testid="degree-home-loader">
    <SvgLoaderSignal />
  </div>
);

export default Loader;
